export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Tag.vue?vue&type=template&id=7e5182c5&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Tag.vue?vue&type=template&id=7e5182c5&
// module id = null
// module chunks = 